import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './RoutesHeader.module.sass';

export const RoutesHeader = ({ showTabs, description }) => {
  const { t } = useTranslation();

  const learningPaths = useSelector((state) => state.get('school').get('tabLp'))?.toJS() || {};

  const intersectionOptions = {
    root: null,
    rootMargin: '-20% 0px -70% 0px',
    threshold: 0,
  };

  const callbackIntersection = (entries) => {
    entries.forEach((entry) => {
      const id = entry.target.id;
      const element = document.querySelector(`[href="#${id}"]`);

      if (entry.intersectionRatio > 0) {
        element && element.classList.add(styles.active);
      } else {
        element && element.classList.remove(styles.active);
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackIntersection, intersectionOptions);
    const sections = document.querySelectorAll('#Routes section');

    sections.forEach((element) => observer.observe(element));

    return () => sections.forEach((element) => observer.unobserve(element));
  }, []);

  return (
    <div className={styles.RoutesHeader}>
      {showTabs ? (
        <nav>
          <ul>
            {learningPaths.map((item, index: number) => (
              <li key={`lp-${index}`}>
                <a href={`#lp${index}-${encodeURI(item.title)}`}>{item.title}</a>
              </li>
            ))}
          </ul>
        </nav>
      ) : (
        <p>{description}</p>
      )}
    </div>
  );
};
